import { Tabs } from "@mantine/core";

import Typography from "_components/atoms/typography";

export default function CustomizedTabs ( {
	onChange,
	activeTab,
	list = []
} ) {

	return (
		<Tabs
			onChange = { onChange }
			value    = { activeTab }
		>
			<Tabs.List>

				{list?.map ( item => {

					return (
						<Tabs.Tab
							key   = { item.value }
							value = { item.value }
						>
							<Typography
								unstyled
								title = { item.label }
							/>
						</Tabs.Tab>
					);
				}
				) }
			</Tabs.List>

		</Tabs>
	);
}
